import gql from "graphql-tag";


export const RN_MP_COPY = gql`
    mutation($mp_id:Int,$date:String,$user_id:Int, $briefing_id:Int) {
        RnMpCopy(mp_id:$mp_id,date:$date,user_id:$user_id,briefing_id:$briefing_id) {
            id
        }
    }
`;